/**
 * Strength Unit Enum
 *
 * Values synced with backend StrengthUnitEnum.
 * @see backend/src/backend/db/constants/strength_unit.py
 *
 * Backend values:
 * - MG = "mg"
 * - G = "g"
 * - MCG = "mcg"
 * - ML = "mL"
 * - L = "L"
 * - MG_ML = "mg/mL"
 * - MCG_ML = "mcg/mL"
 */

export const StrengthUnit = {
    MG: "mg",           // miligrama
    G: "g",             // grama
    MCG: "mcg",         // micrograma
    ML: "mL",           // mililitro
    L: "L",             // litro
    MG_ML: "mg/mL",     // miligrama por mililitro
    MCG_ML: "mcg/mL",   // micrograma por mililitro
};

/**
 * Get strength unit options for select components
 * @returns {Array} Array of {value, label} objects
 */
export const getStrengthUnitOptions = () =>
    Object.entries(StrengthUnit).map(([key, value]) => ({
        value: value,
        label: value
    }));
